import { helper } from '@ember/component/helper';
import { isHTMLSafe, htmlSafe } from '@ember/template';

// «UI nuova» (M14-C1): the first letter of a translated text as a capital, for a text that starts a sentence or a
// label in the new UI while its classic translation is lower case («modifica» → «Modifica»). Works where CSS cannot
// (placeholder, title, aria-label, option text). The classic translation values are not touched.
//   {{nv-cap (t 'edit')}}   placeholder={{nv-cap (t 'name')}}
// A SafeString stays safe (only its first character changes); null / undefined / non-strings pass through.
function nvCap([value]) {
  if (value == null) return value;
  const safe = isHTMLSafe(value);
  const text = safe ? value.toString() : value;
  if (typeof text !== 'string' || !text) return value;
  const out = text.charAt(0).toLocaleUpperCase() + text.slice(1);
  return safe ? htmlSafe(out) : out;
}
var nvCap$1 = helper(nvCap);

export { nvCap$1 as default, nvCap };
//# sourceMappingURL=nv-cap.js.map
